<div class="staff-import-wrapper">
    <div id="staff-import" class="staff-import">
        <div class="card-box">
            <h2>Importar Atributos</h2>
            <div class="button-row">
                <button mat-raised-button color="accent" (click)="staffExcelImport()">Importar</button>
            </div>
        </div>
    </div>

    <div class="staff-import-content">
        <div class="left">
            <app-attribute-parameter [appExcelColumnPanel]="appExcelColumnPanel" #appParameterPanel></app-attribute-parameter>
        </div>

        <div class="right">
            <app-attribute-excel-panel #appExcelColumnPanel></app-attribute-excel-panel>
        </div>
    </div>
</div> 